import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material"
import React from "react"
import styles from "../../Quiz.module.scss"
import TableNoRecords from "components/TableNoRecords"
import ContestRow from "./ContestRow"

const StyledTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  "& .MuiTableCell-root": {
    padding: "14px 24px 12px 0px",
    backgroundColor: theme.palette.background.main,
    borderBottom: `2px solid ${theme.palette.background.default}`,
    boxSizing: "border-box",
    "&:first-of-type": {
      paddingLeft: 6,
      paddingRight: 27
    },
    "&:last-child": {
      paddingRight: 0
    }
  },

  "& .MuiTableCell-head": {
    verticalAlign: "bottom",
    position: "relative",
    "&:last-child": {
      paddingRight: 0
    }
  }
}))

const ContestTable = ({ weeklyQuizList, isLoading }) => {
  return (
    <Paper className={styles.container}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <StyledTable stickyHeader aria-label="contest table">
          <TableHead>
            <TableRow>
              {ContestColumns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}>
                  <Typography className={styles.header} variant="body2Regular">
                    {column.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {weeklyQuizList?.length ? (
              <>
                {weeklyQuizList?.map((row) => {
                  return <ContestRow key={row.id} row={row} columns={ContestColumns} />
                })}
              </>
            ) : (
              <TableNoRecords
                colSpan={9}
                label={
                  isLoading ? "Please wait, we are fetching the contests..." : "No Contests Found"
                }
              />
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </Paper>
  )
}

export default ContestTable

const ContestColumns = [
  {
    id: "Name",
    label: "Name",
    align: "left",
    minWidth: 80
  },
  {
    id: "Created",
    label: "Created",
    align: "center",
    minWidth: 80
  },
  {
    id: "Status",
    label: "Status",
    align: "center",
    minWidth: 80
  },
  {
    id: "Actions",
    label: "Actions",
    align: "center",
    minWidth: 80
  }
]
